import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { IconsService } from '@cpcac/common/core/services';

/** Base app component. */
@Component({
  selector: 'cpcaw-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {

  private readonly iconsService = inject(IconsService);

  public constructor() {
    this.iconsService.registerIcons();
  }
}
